<template>
  <div class="main" ref="main">
    <div class="left">
      <left/>
    </div>
    <div class="right">
      <div class="rightTop"><main-header/></div>
      <div class="rightBottom" ref="rightBottom">
        <router-view/>
      </div>

    </div>
  </div>
</template>

<script>
import left from '@/components/Left'
import MainHeader from '@/components/Header'
export default {
  name: 'joinlist',
  data () {
    return {

    }
  },
  mounted(){
    let wHeight=window.innerHeight
    this.$refs.main.style='min-height:'+wHeight+'px'
    this.$refs.rightBottom.style='min-height:'+(wHeight-120)+'px'
  },
  components:{
    MainHeader,
    left
  }
}
</script>
<style scoped>
  .main {min-height:750px;background:#f2f3f5;}
  .left {
    width:120px;
    background:#fff;
    min-height:100%;
    position: fixed;
    left:0;
  }
  .right {
    padding-top:60px;
    margin-left:135px;
  }
  .rightTop {
    width:100%;
    height:60px;
    position: fixed;
    top:0;
    z-index:1000;
  }
  .rightBottom {
    padding:25px;
    background:#fff;
  }
</style>



// WEBPACK FOOTER //
// src/views/Main.vue